'use es6';

import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
const getDistractionFreeState = basicSelector(state => state.distractionFree);
export const getDistractionFreeInProgress = createSelector(getDistractionFreeState, distractionFreeState => distractionFreeState && distractionFreeState.distractionFreeInProgress);